import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FeatureTogglesFacade } from '@cigna/features';
import { OmniChatFacade } from '@cigna/omni/chat-state';
import { OmniCommChannelFacade } from '@cigna/omni/comm-channel-feature';
import { OmniConversationsFacade } from '@cigna/omni/conversations-state';
import { OmniAnalyticsService } from '@cigna/omni/shared';
import { OutroObj } from '../interfaces/outro.interface';

@Component({
  selector: 'cigna-omni-messaging-outro',
  templateUrl: './outro.component.html',
  styleUrls: ['./outro.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OmniMessagingOutroComponent {
  @Input() outro: OutroObj;
  @Input() isHistory: boolean;
  @Input() shouldEnablePreChatWelcome: boolean;
  @Input() canReplaceBackToPreviousWithEndChat: boolean;
  @Input() agentLeftMessageCopy: string;
  @Input() public isEapUser: boolean;
  isEvernorthEnabled$ = this.featureTogglesFacade.featuresEnabled([
    'isEvernorthEnabled',
  ]);
  canUpdateAnalyticsData$ = this.featureTogglesFacade.featuresEnabled([
    'canUpdateAnalyticsData',
  ]);

  constructor(
    private featureTogglesFacade: FeatureTogglesFacade,
    private commChannelFacade: OmniCommChannelFacade,
    private chatFacade: OmniChatFacade,
    private conversationFacade: OmniConversationsFacade,
    private analytics: OmniAnalyticsService,
  ) {}

  public backTostart() {
    if (this.canReplaceBackToPreviousWithEndChat) {
      this.chatFacade.closeDialog();
      this.conversationFacade.setConversationId('');
    } else {
      const paramTags = this.isEapUser ? ['advocate', 'member'] : ['default'];
      this.conversationFacade.setConversationId('');
      this.conversationFacade.backToStart();
      this.commChannelFacade.interact(
        {
          buttonText: 'Chat with a Guide',
          buttonId: 'chatGuide',
        },
        { tags: paramTags },
        false,
      );
    }
  }

  downloadTranscript(canUpdateAnalyticsData: boolean) {
    const innerContents = document.querySelector('#printSection')?.innerHTML;
    const printWindow = window.open('', '_blank');
    if (printWindow && innerContents) {
      printWindow.document.body.innerHTML = innerContents;
      printWindow.document.head.innerHTML = document.head.innerHTML;
      printWindow.document.close();
      printWindow.focus();
      // adding setTimeout to support print in Safari
      setTimeout(() => {
        printWindow.print();
        printWindow.close();
      }, 0);
    }
    if (canUpdateAnalyticsData) {
      this.analytics.updateAdobeStore({
        event: 'pageAction',
        actionData: {
          actionName: 'downloadTranscript',
          hitType: 'action',
          widgetName: 'chat-download-transcript',
          customLinkText: 'Download Transcript',
          requirementId: 'ac24072',
          userStory: 'ODCTC-593',
        },
      });
    } else {
      this.analytics.trackEvent('trackDownloadTranscriptClick', {
        linkLabel: 'Download Transcript',
      });
    }
  }
}
